import * as React from 'react';
import Svg, {G, Path, Defs, ClipPath} from 'react-native-svg';
interface IProps {
  size?: number;
  color?: string;
}
const NewHomeFilledIcon: React.FC<IProps> = (props) => (
  <Svg width="33" height="32" viewBox="0 0 33 32" fill="none">
    <Path d="M4.5 12L16.5 2.66663L28.5 12V26.6666C28.5 27.3739 28.219 28.0521 27.719 28.5522C27.2189 29.0523 26.5406 29.3333 25.8333 29.3333H7.16667C6.45942 29.3333 5.78115 29.0523 5.28105 28.5522C4.78095 28.0521 4.5 27.3739 4.5 26.6666V12Z" fill={props.color} />
    <Path d="M12.5 29.3333V16H20.5V29.3333" fill={props.color} />
    <Path d="M12.5 29.3333V16H20.5V29.3333M4.5 12L16.5 2.66663L28.5 12V26.6666C28.5 27.3739 28.219 28.0521 27.719 28.5522C27.2189 29.0523 26.5406 29.3333 25.8333 29.3333H7.16667C6.45942 29.3333 5.78115 29.0523 5.28105 28.5522C4.78095 28.0521 4.5 27.3739 4.5 26.6666V12Z" stroke={props.color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);
export default NewHomeFilledIcon;
